import React from 'react'
import BeforeHintForm from 'ui-shared/Hints/TImeBeforeHint/BeforeHintForm'
import Kdivider from 'ui-shared/LayoutComponents/Kdivider'
import BaseCfgTab from './BaseCfgTab'

const FoodServiceCfgTab: React.FC = (props) => {
  return (
    <BaseCfgTab {...props} servName="foodService">
      <Kdivider title="Suggestions" headingLevel="h1" />
      <BeforeHintForm
        arrayInputSource="foodService.timeBeforeHint"
        defaultHintSource="foodService.defaultTimeBeforeHint"
        togglerInputSource="foodService.showTimeBeforeHint"
        accordionText={[
          'beforeCateringHintAccordionText1',
          'beforeCateringHintAccordionText2',
          'beforeCateringHintAccordionText3',
        ]}
      />
    </BaseCfgTab>
  )
}

export default FoodServiceCfgTab
